module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av688-77637ee2fc4fa9deb2561e32f9f6a1a3.jpg";